import { defineStore } from 'pinia'

import type { OrderInvoiceStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useOrderInvoiceStore = defineStore('order-invoice', {
  state: (): OrderInvoiceStore => ({
    loading: false,
    previewLoading: false,
    saved: null,
    draft: null,
    invoices: [],
    preview: null,
    previewState: 'automatic',
  }),
  actions,
  getters,
})
